import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import SwBanner from "../components/swbanner";
import BuyAdBanner from "../components/buyadbanner";
import * as wActs from "../actions/website-actions";
class SideBanners extends Component {

  constructor(props) {
    super(props);
    this.state = {
      max: props.max ? props.max : "4",
      count: props.count ? props.count : "10",
    };
  }

  render() {
    let tmp = this.props.Template;
    let acc = "NL";
    if(!wActs.isNullOrUndefined(tmp)) {
      if(!wActs.isNullOrUndefined(tmp.Country) && !wActs.isNullOrEmpty(tmp.Country.Code)) {
        acc=tmp.Country.Code;
      }
    }
    let url = "";
    if(typeof window !== "undefined") {
      url = window.location.href;
    } else {
      url = "https://www.fakeurl.com/dude" + this.props.Website.ServerParams.Query;
    }
    let qcc = wActs.getParameterByName("country",url,"")
    if(!wActs.isNullOrEmpty(qcc)) { acc = qcc; }
    let mob = this.props.Website.ServerParams.IsMobile;

    if(this.props.Website.Page.Template.Name == "Link" && this.props.LinkLoaded) {
      acc = this.props.Link.Country.Code;
    }



    return (
    <div className="col_20 desktop-only">
      <div key={"homepage-right-banners"} style={{float: "right"}} className="banner-sidebar">
        <React.Fragment>
          <div className={"flex-center"} style={{flexDirection: "column"}}>
            <SwBanner BannersInc={this.props.BannersInc}  BannersLoader={this.props.BannersLoader} apiAnonId={this.props.Website.Request.AnonymousId} country={acc} tagText={this.props.HtmlSections['Adserver-200x333-featured']} className={"newbottom-fbanners"}></SwBanner>
          </div>
          <div className={"flex-center"} style={{flexDirection: "column"}}>
            <SwBanner BannersInc={this.props.BannersInc}  BannersLoader={this.props.BannersLoader} apiAnonId={this.props.Website.Request.AnonymousId} country={acc} tagText={this.props.HtmlSections['Adserver-200x200-featured']} className={"newbottom-fbanners"}></SwBanner>
          </div>
          <div className={"flex-center"} style={{flexDirection: "column"}}>
            <SwBanner BannersInc={this.props.BannersInc}  BannersLoader={this.props.BannersLoader} count={this.state.count} maxStandard={this.state.max} apiAnonId={this.props.Website.Request.AnonymousId} country={acc}  tagText={this.props.HtmlSections['Adserver-200x333-sidebar']} className={"newbottom-fbanners"}>
              <BuyAdBanner LocalCSS={this.props.Website.Settings.LocalCSS} size={"200x333"} textButton={this.getTranslation("page.advertise.advertisehere")} textTop={this.getTranslation("page.advertise.getxtimesmorevisitors")} textBottom={this.getTranslation("page.advertise.buyabanneraddtoday")}/>
            </SwBanner>
          </div>
          <div className={"flex-center"} style={{flexDirection: "column"}}>
            <SwBanner BannersInc={this.props.BannersInc}  BannersLoader={this.props.BannersLoader} count={this.state.count} maxStandard={this.state.max} apiAnonId={this.props.Website.Request.AnonymousId} country={acc} tagText={this.props.HtmlSections['Adserver-200x200-sidebar']} className={"newbottom-fbanners"}>
              <BuyAdBanner LocalCSS={this.props.Website.Settings.LocalCSS} size={"200x200"} textButton={this.getTranslation("page.advertise.advertisehere")} tagText={this.props.HtmlSections['Adserver-200x200-sidebar']} textTop={this.getTranslation("page.advertise.getxtimesmorevisitors")} textBottom={this.getTranslation("page.advertise.buyabanneraddtoday")}/>
            </SwBanner>
          </div>
          <div className={"flex-center"} style={{flexDirection: "column"}}>
            <SwBanner BannersInc={this.props.BannersInc} BannersLoader={this.props.BannersLoader} count={this.state.count} maxStandard={this.state.max} apiAnonId={this.props.Website.Request.AnonymousId} country={acc} tagText={this.props.HtmlSections['Adserver-200x100-sidebar']} className={"newbottom-fbanners"}></SwBanner>
          </div>
        </React.Fragment>
      </div>
    </div>
    )
  }
  getTranslation(key) {
    return this.props.Website.Translations[key];
  }

}
const mapStateToProps = (state) => {
  return {
    LinkLoaded: state.Links.Link.Loaded,
    Link: state.Links.Link.ApiResult.Result,
    Website: state.Website,
    PageType: state.Website.PageType,
    HtmlSections: state.Website.Settings.HtmlSections,
    Template: state.Website.Page.Template,
    BannersLoader: state.Ads.BannersLoader,
    BannersInc: state.Ads.BannersInc
  };
}

export default connect(mapStateToProps)(SideBanners);
